module.exports = __webpack_public_path__ + "static/media/cardcol.7d1846c5.png";